'use client';

import type { FC } from 'react';
import { useEffect } from 'react';
import { Toaster } from 'sonner';

import { configureToasts, toastClassNames, toastIcons, type VariantHeaders } from '.';

interface Props {
  /** Per-variant header copy. Apps keep ownership of their own translations. */
  variantHeaders?: VariantHeaders;
  /** Render the message only, with no header row. */
  hideHeader?: boolean;
}

export const AppToaster: FC<Props> = ({ variantHeaders, hideHeader }) => {
  useEffect(() => {
    configureToasts({ variantHeaders, hideHeader });
  }, [variantHeaders, hideHeader]);

  return (
    <Toaster
      position="top-center"
      expand
      closeButton
      icons={toastIcons}
      toastOptions={{ unstyled: true, classNames: toastClassNames(hideHeader) }}
    />
  );
};
